import { createSlice } from "@reduxjs/toolkit";

const productOrdersSlice = createSlice({
  name: "productOrders",
  initialState: {
    loading: false,
    data: [],
    total: 0,
    page: 0,
    limit: 10,
    error: null,
  },
  reducers: {
    getProductOrdersRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getProductOrdersSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.meta?.page || 0;
      state.limit = action.meta?.limit || 10;
    },
    getProductOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    bookNowStatusChangeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    bookNowStatusChangeSuccess: (state) => {
      state.loading = false;
    },
    bookNowStatusChangeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    changeProdStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    changeProdStatusSuccess: (state) => {
      state.loading = false;
    },
    changeProdStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getProductOrdersRequest,
  getProductOrdersSuccess,
  getProductOrdersFailure,
  bookNowStatusChangeRequest,
  bookNowStatusChangeSuccess,
  bookNowStatusChangeFailure,
  changeProdStatusRequest,
  changeProdStatusSuccess,
  changeProdStatusFailure,
} = productOrdersSlice.actions;

export default productOrdersSlice.reducer;
